import { render, staticRenderFns } from "./VipLottie.vue?vue&type=template&id=4e324694&"
import script from "./VipLottie.vue?vue&type=script&lang=js&"
export * from "./VipLottie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports